/* eslint-disable max-len */
import React from 'react';

function ProductsTooltip() {
    return (
        <div id="tooltip-information" role="tooltip" className="inline-block absolute z-10 pt-1.5 px-2.5 pb-3 bg-white rounded-lg shadow-s2 w-[173px]">
            <p className="text-xs font-semibold text-[#555259]">Delivery Lead Time</p>
            <div className="flex mt-2.5">
                <div className="w-1/2">
                    <div className="flex">
                        <p className="text-xs3 font-semibold text-[090406]">Category</p>
                        <p className="text-xs3 font-normal text-white px-1 bg-[#555259] rounded-[3px] w-fit ml-1.5">A</p>
                    </div>
                </div>
                <div className="w-1/2">
                    <p className="text-xs3 font-normal text-[#000000]">10 Days Maximum</p>
                </div>
            </div>
            <div className="flex mt-3">
                <div className="w-1/2">
                    <div className="flex">
                        <p className="text-xs3 font-semibold text-[090406]">Category</p>
                        <p className="text-xs3 font-normal text-white px-1 bg-[#555259] rounded-[3px] w-fit ml-1.5">B</p>
                    </div>
                </div>
                <div className="w-1/2">
                    <p className="text-xs3 font-normal text-[#000000]">21 Days Maximum</p>
                </div>
            </div>
            <div className="flex mt-3">
                <div className="w-1/2">
                    <div className="flex">
                        <p className="text-xs3 font-semibold text-[090406]">Category</p>
                        <p className="text-xs3 font-normal text-white px-1 bg-[#555259] rounded-[3px] w-fit ml-1.5">C</p>
                    </div>
                </div>
                <div className="w-1/2">
                    <p className="text-xs3 font-normal text-[#000000]">45 Days Maximum</p>
                </div>
            </div>
            <div className="tooltip-arrow" data-popper-arrow />
        </div>
    );
}

export default ProductsTooltip;
